/*
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: enbo.zhou@dsicm.com
 * @Date: 2021-07-14 10:27:31
 * @LastEditors: enbo.zhou@dsicm.com
 * @LastEditTime: 2021-07-15 16:29:37
 * @FilePath: /dsicm-admin-web/src/views/StandardDatabase/src/case-3/mixins.table.config.js
 */
export default{
    data(){
        return{
            drugTableListConfig: [
                {
                    label: '序号',
                    align: 'center',
                    fixed: 'left',
                    render: (h, scope) => {
                        return <span slot="reference">{scope.$index * 1 + 1}</span>
                    },
                },
                {
                    label: '一级类目代码',
                    align: 'center',
                    prop: 'categoryCode',
                    showOverflowTooltip: true
                },
        
                {
                    label: '一级类目名称',
                    align: 'center',
                    prop: 'categoryName',
                },
                {
                    label: '二级类目代码',
                    align: 'center',
                    prop: "secondCategoryCode",
                    showOverflowTooltip: true
                },
                {
                    label: '二级类目名称',
                    align: 'center',
                    prop: 'secondCategoryName',
                    showOverflowTooltip: true
                },
                {
                    label: '三级类目代码',
                    align: 'center',
                    prop: 'thirdCategoryCode',
                },
                {
                    label: '三级类目名称',
                    align: 'center',
                    prop: 'thirdCategoryName',
                },
                {
                    label: '检查项目名称',
                    align: 'center',
                    prop: 'name',
                },
                {
                    label: '检查项目代码',
                    align: 'center',
                    prop: 'examineCode',
                    showOverflowTooltip: true
                },
                {
                    label: '对应检查部位',
                    align: 'center',
                    prop: 'operationPosition',
                    size: 'mini'
                },
                {
                    label: '状态',
                    align: 'center',
                    render: (h, scope) => {
                        return <span slot="reference">{!scope.row.status ? '已启用' :'已停用'}</span>
                    },
                },
                {
                    label: '操作',
                    align: 'center',
                    fixed: "right",
                    width: '150px',
                    render: (h, scope) => {
                        return h('div', [
                            h( 'el-button', {
                                props: { type: 'text', size: 'mini' },
                                on: {
                                click: () => {
                                    this.editHandel(scope.row)
                                },
                                },
                            }, '编辑' ),
                            h( 'el-button', {
                                props: { type: 'text', size: 'mini' },
                                on: {
                                    click: () => {
                                        this.blockUp(scope.row)
                                    },
                                },
                            }, !scope.row.status ? '停用' :'启用'),
                            h( 'el-button',  {
                                props: { type: 'text', size: 'mini' },
                                on: {
                                    click: () => {
                                        this.removeHandel(scope)
                                    },
                                },
                            }, '删除'  ),
                        ])
                    },
                },
                
            ],
        }
    }
}